<template>
  <div>
    <el-row :gutter="10">
      <el-col class="mb-3" :sm="{span: 24}" :md="{span: 7}" :lg="{span: 7}">
        <div class="cp-tree">
          <b-button
            pill
            size="sm"
            class="mb-3"
            variant="outline-success"
            @click="add('addTop')"
            v-if="allow('A')"
          >{{$l('btn_add_top_level') || '新增顶级分类'}}</b-button>
          <el-tree
            :data="treeData"
            default-expand-all
            node-key="code"
            ref="tree"
            :expand-on-click-node="false"
            @node-click="handleNodeClick"
            highlight-current
            check-strictly
            :props="defaultProps"
          ></el-tree>
        </div>
      </el-col>
      <el-col :sm="{span: 24}" :md="{span: 17}" :lg="{span: 17}">
        <el-row>
          <el-col :span="24">
            <b-button
              class="mr-2"
              size="sm"
              variant="outline-success"
              @click="add('add')"
              v-if="allow('A')"
              v-show="addBtn"
            >{{$l('btn_add_ategory') || '新增分类'}}</b-button>
            <b-button
              class="mr-2"
              size="sm"
              variant="outline-success"
              @click="save"
              v-if="allow('A')"
              v-show="saveBtn"
            >{{$l('btn_save') || '保存'}}</b-button>
            <b-button
              class="mr-2"
              size="sm"
              variant="outline-success"
              @click="modify"
              v-if="allow('M')"
              v-show="modBtn"
            >{{$l('btn_update') || '修改'}}</b-button>
            <b-button
              class="mr-2"
              size="sm"
              variant="outline-success"
              @click="del"
              v-if="allow('D')"
              v-show="delBtn"
            >{{$l('btn_del') || '删除'}}</b-button>
            <b-button
              class="mr-2"
              size="sm"
              variant="outline-success"
              @click="actExport"
              v-if="allow('E')"
            >{{$l('btn_excel') || '导出'}}</b-button>
          </el-col>
        </el-row>
        <div class="d2-mt">
          <el-form ref="formData" :model="formData">
            <el-row :gutter="20">
              <el-col :sm="{span: 12}" :md="{span: 8}" :lg="{span: 8}">
                <el-form-item :label="$l('form_label_isLastFlag') || '是否末级'">
                  <el-radio-group
                    v-model="formData.isLastFlag"
                    style="width: 100%"
                    :disabled="available"
                  >
                    <el-radio label="Y">{{$l('form_label_yes') || '是'}}</el-radio>
                    <el-radio label="N">{{$l('form_label_no') || '否'}}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :sm="{span: 12}" :md="{span: 8}" :lg="{span: 8}">
                <el-form-item :label="$l('form_label_status') || '有效状态'">
                  <el-radio-group
                    v-model="formData.fabricCategoryStatus"
                    style="width: 100%"
                    disabled
                  >
                    <el-radio label="Y">{{$l('form_label_effective') || '有效'}}</el-radio>
                    <el-radio label="N">{{$l('form_label_invalid') || '无效'}}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :sm="{span: 24}" :md="{span: 16}" :lg="{span: 16}">
                <el-form-item :label="$l('form_label_fabricCategoryNameCn') || '中文分类名称'">
                  <el-input
                    @input="fabricCategoryNameCnChange"
                    clearable
                    size="small"
                    :disabled="available"
                    v-model="formData.fabricCategoryNameCn"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :sm="{span: 24}" :md="{span: 16}" :lg="{span: 16}">
                <el-form-item :label="$l('form_label_fabricCategoryNameEn') || '英文分类名称'">
                  <el-input
                    @input="fabricCategoryNameEnChange"
                    clearable
                    size="small"
                    :disabled="available"
                    v-model="formData.fabricCategoryNameEn"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :sm="{span: 24}" :md="{span: 16}" :lg="{span: 16}">
                <el-form-item :label="$l('form_label_fabricCategoryFullNameCn') || '中文分类全称'">
                  <el-input
                    clearable
                    size="small"
                    disabled
                    v-model="formData.fabricCategoryFullNameCn"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :sm="{span: 24}" :md="{span: 16}" :lg="{span: 16}">
                <el-form-item :label="$l('form_label_fabricCategoryFullNameEn') || '英文分类全称'">
                  <el-input
                    clearable
                    size="small"
                    disabled
                    v-model="formData.fabricCategoryFullNameEn"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :sm="{span: 24}" :md="{span: 16}" :lg="{span: 16}">
                <el-form-item :label="$l('form_label_parentCategoryNameCn') || '中文上级分类名称'">
                  <el-input
                    clearable
                    size="small"
                    :disabled="true"
                    v-model="formData.parentCategoryNameCn"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :sm="{span: 24}" :md="{span: 16}" :lg="{span: 16}">
                <el-form-item :label="$l('form_label_parentCategoryNameEn') || '英文上级分类名称'">
                  <el-input
                    clearable
                    size="small"
                    :disabled="true"
                    v-model="formData.parentCategoryNameEn"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :sm="{span: 24}" :md="{span: 16}" :lg="{span: 16}">
                <el-form-item :label="$l('form_label_level') || '层级'">
                  <el-input clearable size="small" :disabled="true" v-model="formData.levelNo"></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <div style="font-size: 14px; color: #717171;">
                  <span>Modify：{{formData.updatedBy?formData.updatedBy:'--'}} at {{formData.updatedTime?formData.updatedTime:'--'}}</span>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    treeData: {
      default: () => []
    }
  },
  components: {},
  data() {
    return {
      available: true, // 表单输入是否禁用
      addBtn: false, // 新增按钮true
      saveBtn: false, // 保存按钮
      modBtn: false, // 修改按钮
      delBtn: false, // 删除按钮
      btnText: "", // 按钮说明
      formData: {
        fabricCategoryCode: "", // 分类主键编码
        fabricCategoryNameCn: "", // 分类名称
        fabricCategoryNameEn: "", // 分类名称
        fabricCategoryFullNameCn: "", // 分类全称
        fabricCategoryFullNameEn: "", // 分类全称
        levelNo: "", // 层级
        isLastFlag: "", //是否末级
        parentCategoryCode: "无", // 上级分类编码
        parentCategoryNameCn: "", // 上级分类名称
        parentCategoryNameEn: "", // 上级分类名称
        fabricCategoryStatus: "", // 状态
        createdBy: "",
        createdTime: "",
        updatedBy: "",
        updatedTime: ""
      },
      // 当前选中tree节点的数据
      currTreeData: {
        fabricCategoryCode: "",
        fabricCategoryNameCn: "",
        fabricCategoryNameEn: "",
        parentCategoryCode: "",
        levelNo: "",
        fabricCategoryFullNameCn: "",
        fabricCategoryFullNameEn: "",
        parentCategoryNameCn: "",
        parentCategoryNameEn: ""
      },
      defaultProps: {
        children: "children",
        label: "fabricCategoryName"
      }
    };
  },
  mounted() {
    this.clear();
  },
  activated() {
    this.clear();
  },
  methods: {
    //中文名称变动
    fabricCategoryNameCnChange(e) {
      if (this.btnText === "modi") {
        if (parseInt(this.formData.levelNo) === 1) {
          this.formData.fabricCategoryFullNameCn = e;
        } else {
          let temp = this.formData.fabricCategoryFullNameCn;
          if (e) {
            this.formData.fabricCategoryFullNameCn =
              temp.substring(0, temp.lastIndexOf(".")) + "." + e;
          } else {
            this.formData.fabricCategoryFullNameCn =
              temp.substring(0, temp.lastIndexOf(".")) + ".";
          }
        }
      } else if (this.btnText === "add") {
        if (e) {
          this.formData.fabricCategoryFullNameCn =
            this.currTreeData.fabricCategoryFullNameCn + "." + e;
        } else {
          this.formData.fabricCategoryFullNameCn =
            this.currTreeData.fabricCategoryFullNameCn + ".";
        }
      } else if (this.btnText === "addTop") {
        this.formData.fabricCategoryFullNameCn = e;
      }
    },
    //英文名称变动
    fabricCategoryNameEnChange(e) {
      if (this.btnText === "modi") {
        if (parseInt(this.formData.levelNo) === 1) {
          this.formData.fabricCategoryFullNameEn = e;
        } else {
          let temp = this.formData.fabricCategoryFullNameEn;
          if (e) {
            this.formData.fabricCategoryFullNameEn =
              temp.substring(0, temp.lastIndexOf(".")) + "." + e;
          } else {
            this.formData.fabricCategoryFullNameEn =
              temp.substring(0, temp.lastIndexOf(".")) + ".";
          }
        }
      } else if (this.btnText === "add") {
        if (e) {
          this.formData.fabricCategoryFullNameEn =
            this.currTreeData.fabricCategoryFullNameEn + "." + e;
        } else {
          this.formData.fabricCategoryFullNameEn =
            this.currTreeData.fabricCategoryFullNameEn + ".";
        }
      } else if (this.btnText === "addTop") {
        this.formData.fabricCategoryFullNameEn = e;
      }
    },
    handleNodeClick(data, node) {
      if (this.saveBtn) {
        this.$confirm(this.$l('INDEX.tips_question_doYouWantToLeave') || '是否离开？点击确认当前数据将不做保存', this.$l('INDEX.tips_question_title') || '友情提示', {
          confirmButtonText: this.$l('INDEX.tips_confirm') || "确认",
          cancelButtonText: this.$l('INDEX.tips_cancel') || "取消",
          type: "warning"
        }).then(() => {
          this.cpTreeDetail(data, node);
        });
      } else {
        this.cpTreeDetail(data, node);
      }
    },
    // 加载详情
    cpTreeDetail(data, node) {
      //分类详情查询
      let detailParam = { fabricCategoryCode: data.fabricCategoryCode };
      this.$api.masterFabricCategory_detail(detailParam).then(res => {
        this.clear();
        this.btnIsShow("detail");
        this.formData = res.body;
        this.currTreeData.fabricCategoryCode = res.body.fabricCategoryCode;
        this.currTreeData.fabricCategoryNameCn = res.body.fabricCategoryNameCn;
        this.currTreeData.fabricCategoryNameEn = res.body.fabricCategoryNameEn;
        this.currTreeData.parentCategoryCode = res.body.parentCategoryCode;
        this.currTreeData.levelNo = res.body.levelNo;
        this.currTreeData.fabricCategoryFullNameCn =
          res.body.fabricCategoryFullNameCn;
        this.currTreeData.fabricCategoryFullNameEn =
          res.body.fabricCategoryFullNameEn;
        this.currTreeData.parentCategoryNameCn = res.body.parentCategoryNameCn;
        this.currTreeData.parentCategoryNameEn = res.body.parentCategoryNameEn;
        this.isLastFlagChange();
      });
    },
    add(val) {
      this.clear();
      this.btnIsShow(val);
      this.formData.fabricCategoryStatus = "Y";
      if (val === "addTop") {
        this.formData.levelNo = 1;
        this.formData.parentCategoryNameCn = "--";
        this.formData.parentCategoryNameEn = "--";
        return;
      }
      this.formData.parentCategoryCode = this.currTreeData.fabricCategoryCode;
      this.formData.parentCategoryNameCn = this.currTreeData.fabricCategoryNameCn;
      this.formData.parentCategoryNameEn = this.currTreeData.fabricCategoryNameEn;
      this.formData.levelNo = parseInt(this.currTreeData.levelNo) + 1;
      this.formData.fabricCategoryFullNameCn =
        this.currTreeData.fabricCategoryFullNameCn + ".";
      this.formData.fabricCategoryFullNameEn =
        this.currTreeData.fabricCategoryFullNameEn + ".";
    },
    //判断是不是末级节点
    isLastFlagChange() {
      if (this.formData.isLastFlag === "Y") {
        this.addBtn = false;
      } else {
        this.addBtn = true;
      }
    },
    // 根据传入方法控制表单、新增按钮、保存按钮、修改按钮、删除按钮显示状态
    btnIsShow(method) {
      this.btnText = method;
      if (method === "modi" || method === "add" || method === "addTop") {
        this.available = false;
        this.saveBtn = true;
        this.addBtn = false;
        this.modBtn = false;
        this.delBtn = false;
      } else if (method === "detail") {
        this.available = true;
        this.saveBtn = false;
        this.addBtn = true;
        this.modBtn = true;
        this.delBtn = true;
      }
    },
    save() {
      if (this.isEmpty()) {
        return;
      }
      this.$api
        .masterFabricCategory_save(this.formData)
        .then(res => {
          this.$message.success(this.$l('INDEX.tips_save_ok') || "保存成功！");
          this.clear();
          this.$emit("submit");
        })
        .catch(err => {
          console.log(err);
        });
    },
    modify() {
      this.btnIsShow("modi");
    },
    del() {
      if (this.formData.fabricCategoryCode === "") {
        this.$message.warning(this.$l('INDEX.tips_question_del_rows') || "请先选择要删除的数据!");
        return;
      }
      this.$confirm(
        this.$l('INDEX.tips_question_delete') || `是否删除?`,
        this.$l('INDEX.tips_question_title') || '友情提示',
        {
          confirmButtonText: this.$l('INDEX.tips_confirm') || "确认",
          cancelButtonText: this.$l('INDEX.tips_cancel') || "取消",
          type: "warning"
        }
      ).then(() => {
        this.$api
          .masterFabricCategory_del({
            fabricCategoryCode: this.formData.fabricCategoryCode
          })
          .then(res => {
            this.$message({
              type: "success",
              message: this.$l('INDEX.tips_delete_ok') || "删除成功！"
            });
            this.clear();
            this.$emit("submit");
          });
      });
    },
    isEmpty() {
      if (this.formData.isLastFlag === "") {
        this.$message.warning(this.$l('tips_psflon') || "请选择是否末级!");
        return true;
      }
      if (this.formData.fabricCategoryStatus === "") {
        this.$message.warning(this.$l('tips_psavs') || "请选择有效状态!");
        return true;
      }
      if (this.formData.fabricCategoryNameCn === "") {
        this.$message.warning(this.$l('tips_pfitccn') || "请填写中文分类名称!");
        return true;
      }
      if (this.formData.fabricCategoryNameEn === "") {
        this.$message.warning(this.$l('tips_pfitecn') || "请填写英文分类名称!");
        return true;
      }
      if (
        this.btnText !== "addTop" &&
        (this.formData.parentCategoryCode === "" ||
          this.formData.parentCategoryCode === undefined)
      ) {
        this.$message.warning(this.$l('tips_pssc') || "请优先选择上级分类,再点击新增进行操作!");
        return true;
      }
    },
    actExport() {
      let params = {};
      let url = "/digitalCenter/masterFabricCategory/excel";
      let fileName = "面料类别导出";
      this.$api.globalExportData(url, params, fileName);
    },
    clear() {
      this.formData = {
        fabricCategoryCode: "", // 分类主键编码
        fabricCategoryNameCn: "", // 分类名称
        fabricCategoryNameEn: "", // 分类名称
        fabricCategoryFullNameCn: "", // 分类全称
        fabricCategoryFullNameEn: "", // 分类全称
        levelNo: "", // 层级
        isLastFlag: "", //是否末级
        parentCategoryCode: "0", // 上级分类编码
        parentCategoryNameCn: "", // 上级分类名称
        parentCategoryNameEn: "", // 上级分类名称
        fabricCategoryStatus: "", // 状态
        createdBy: "",
        createdTime: "",
        updatedBy: "",
        updatedTime: ""
      };
      this.btnText = "";
      this.available = true;
      this.addBtn = false;
      this.saveBtn = false;
      this.modBtn = false;
      this.delBtn = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.cp-tree {
  height: 480px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 10px; /*滚动条宽度*/
  }
}
</style>
